const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*)(+=._-])[A-Za-z\d!@#$%^&*)(+=._-]{6,}$/;

export const isPasswordInvalid = (password: string): boolean => {
    return !password || !passwordRegex.test(password) || password.length < 8;
};
